export default __webpack_public_path__ + "static/media/kenny.e9b09ef6.png";